import request from './request'

export default {
  listarUsuarios () {
    return request({
      url: '/usuario/listarUsuarios',
      method: 'get'
    })
  },
  buscarUsuario (idUsuario) {
    return request({
      url: `/usuario/buscarUsuario?id=${idUsuario}`,
      method: 'get'
    })
  },
  cadastrarUsuario (obj) {
  // console.log(obj)
    return request({
      url: '/usuario/cadastrarUsuario',
      method: 'post',
      data: obj
    })
  },
  vincularPacoteExames (usuarios, idPacoteExames) {
    return request({
      url: 'usuario/vincularPacoteExames',
      method: 'post',
      data: {
        'usuarios': usuarios,
        'pacote': idPacoteExames
      }
    })
  }
}
